import { Component } from '@angular/core';

@Component({
	selector: 'app-logout',
	template: '',
	standalone: true,
})
export class LogoutComponent {}
